import React, { useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";

import * as XLSX from "xlsx";
import {
  NoDataFoundRow,
  StyledTableCell,
  StyledTableRow,
} from "../../../components/common/StyledTableComponents";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import Loader from "../../../components/common/Loader/Loader";
import { RecruterEarning } from "../../../features/Recruiter/RecruiterReports/Reports";
import { MEDIA_URL } from "../../../api/endpoints";
import MonthDatePicker from "../../../components/common/MonthDatePicker";
import {
  formatAmount,
  formatDate1,
  formatUSAmount,
} from "../../../utils/helpers";
import { CustomButton } from "../../../components/common/LoadingButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getHeadersList } from "./RecruterReports";
const RecruterReports = ({ usertype, RecruiterId = null, activeButton }) => {
  const headers = getHeadersList(activeButton);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [lodaing, setLoading] = useState(false);
  const [hiredMonth, setHiredMonth] = useState(dayjs());
  const [resetFlag, setResetFlag] = useState(false);

  const handleReset = async () => {
    setResetFlag(true);
  };
  const getRecruterEarningReports = async () => {
    setLoading(true);

    try {
      const { payload } = await dispatch(RecruterEarning(data));
      if (payload.status === 200) {
        setData(payload.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (resetFlag) {
      getRecruterEarningReports().then(() => setResetFlag(false));
    }
  }, [resetFlag]);
  useEffect(() => {
    getRecruterEarningReports();
  }, []);

  const exportToExcel = () => {
    const formattedData = data.map((row, index) => {
      const rowData = {
        No: index + 1,
        "Job Title": row.candidate_company[0]?.job_title || "N/A",
        Email: row.candidate_email,
        "Contact Number": row.candidate_contactno,
        Location:
          row.candidate_anylocation === "any"
            ? "Any"
            : row.candidate_specifiedlocation
                .map((item) => item.label)
                .join(", "),
        Expertise: row.candidate_expertise
          .map((expertise) => expertise.label)
          .join(", "),
      };

      if (usertype === "client") {
        rowData[
          "Compensation"
        ] = `$${row.candidate_compensation_from} - $${row.candidate_compensation_to}`;
      }

      if (usertype === "admin") {
        rowData["Client Name"] = clientName;
        rowData["Recruiter Name"] = row.recruiter_name || "N/A";
      }

      rowData["Date of Interest"] = hiringDate;

      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      header: headers,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "InterestedCandidatesReport"
    );
    XLSX.writeFile(workbook, "InterestedCandidatesReport.xlsx");
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // Row on medium screens, column on small screens
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          p: 3,
          borderRadius: "10px",
        }}
      >
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item xs={12} sm={6} md={3}>
            <Box>
              <CustomButton
                variant="contained"
                color="primary"
                sx={{
                  mr: 2,
                }}
                onClick={getRecruterEarningReports}
              >
                Apply
              </CustomButton>
              <Tooltip title="Refresh" arrow>
                <CustomButton color="error" size="small" onClick={handleReset}>
                  <RefreshIcon />
                </CustomButton>{" "}
              </Tooltip>{" "}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {lodaing ? (
        <Loader />
      ) : (
        <>
          <TableContainer
            component={Paper}
            sx={{ width: "100%", margin: "auto", mt: 3 }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {headers?.map((header, index) => (
                    <StyledTableCell key={index}>{header}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  <>
                    {data.map((row, index) => {
                      const CDate = formatDate1(row.candidate_cdate.$date);
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#f5f5f5",
                            },
                            fontSize: "12px",
                          }}
                        >
                          <StyledTableRow>{index + 1}.</StyledTableRow>
                          <StyledTableRow>{CDate}</StyledTableRow>
                          <StyledTableRow>
                            {row.candidate_firstname} {row.candidate_lastname}
                          </StyledTableRow>
                          <StyledTableRow>{row.candidate_email}</StyledTableRow>
                          <StyledTableRow>
                            {row.candidate_contactno}
                          </StyledTableRow>
                        </TableRow>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <NoDataFoundRow
                      colSpan={9}
                      message="Candidates are not available!"
                    />
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </>
  );
};

export default RecruterReports;
